// Storefront <-> currency mapping. Each Shopify storefront natively serves a
// single currency, so switching currency means moving to the matching store
// (per the JA-112 intent: USD -> US site, GBP -> UK site).
const STOREFRONTS = {
    GBP: 'https://uk.jonathanadler.com/',
    USD: 'https://jonathanadler.com/',
};

// The currency this storefront actually renders prices in, injected from Liquid
// (`shop.currency`) in layout/theme.liquid. Falls back to GBP for the UK store.
function getStorefrontCurrency() {
    const injected = (window.SHOP_CURRENCY || '').toUpperCase();
    return STOREFRONTS[injected] ? injected : 'GBP';
}

function handleCurrencyChange(event) {
    const chosen = (event.target.value || '').toUpperCase();
    // Already on the storefront that serves this currency — nothing to do.
    if (chosen === getStorefrontCurrency()) return;
    const destination = STOREFRONTS[chosen];
    if (destination) window.location.href = destination;
}

document.addEventListener('DOMContentLoaded', () => {
    const currencySelectors = document.querySelectorAll(
        '#currency-selector-header, #currency-selector-footer, #currency-selector-drawer, [id^="currency-selector"], .currency-selector select'
    );

    const storefrontCurrency = getStorefrontCurrency();

    currencySelectors.forEach((select) => {
        // Reflect the storefront's real currency so the control matches the
        // prices on the page and survives reloads — no hardcoded default that
        // fights the actual store. On the UK store this resolves to GBP.
        [...select.options].forEach((option) => {
            option.selected = option.value.toUpperCase() === storefrontCurrency;
        });
        if ([...select.options].some((o) => o.value.toUpperCase() === storefrontCurrency)) {
            select.value = storefrontCurrency;
        }

        select.addEventListener('change', handleCurrencyChange);
    });
})


const IS_IOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
document.documentElement.classList.toggle('is-ios', IS_IOS);

function createOrUpdateSwiper(el, optsOverrides = {}) {
  const opts = Object.assign({
    slidesPerView: 1.3,
    spaceBetween: 16,
    scrollbar: {
      el: el.querySelector('.swiper-enhanced-images .swiper-scrollbar') || 
          el.querySelector('.swiper-megamenu-scrollbar') || 
          el.querySelector('.swiper-scrollbar'),
      draggable: true,
      hide: false,
      dragSize: 'auto',
      snapOnRelease: true,
    },
    // Enhanced touch settings for better drag
    allowTouchMove: true,
    grabCursor: true,
    touchEventsTarget: 'wrapper',
    simulateTouch: true,
    resistance: true,
    resistanceRatio: 0.85,
    preventInteractionOnTransition: false,
    touchStartPreventDefault: false,
    touchStartForcePreventDefault: false,
    touchMoveStopPropagation: false,
    touchReleaseOnEdges: true,
    threshold: 5,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    // Disable autoplay - it interferes with manual dragging
    autoplay: false,
    // Observer for dynamic content
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
  }, optsOverrides);

  if (el.swiper) {
    el.swiper.update();
    return el.swiper;
  }
  if (typeof window.Swiper === 'undefined') return null;
  el.swiper = new window.Swiper(el, opts);
  return el.swiper;
}

window.setupEnhancedImages = function setupEnhancedImages(root = document) {
  // Support both old and new class names
  const selectors = [
    '.swiper-enhanced-images .swiper',
    '.swiper-megamenu-images .swiper-megamenu'
  ];
  
  selectors.forEach(selector => {
    root.querySelectorAll(selector).forEach((el) => {
      if (IS_IOS) {
        el.parentElement.classList.add('native-x-scroll');
        return; // keep native scrolling on iOS
      }
      createOrUpdateSwiper(el);
    });
  });

  // Setup native horizontal scroll for containers with native-horizontal-scroll class
  root.querySelectorAll('.native-horizontal-scroll').forEach((container) => {
    setupNativeHorizontalScroll(container);
  });
}

function setupNativeHorizontalScroll(container) {
  const scrollContainer = container.querySelector('.native-scroll-container');
  if (!scrollContainer) return;

  // Add smooth scrolling behavior
  scrollContainer.style.scrollBehavior = 'smooth';
  
  // Add touch support for mobile
  let isScrolling = false;
  let startX = 0;
  let scrollLeft = 0;

  scrollContainer.addEventListener('touchstart', (e) => {
    isScrolling = true;
    startX = e.touches[0].pageX - scrollContainer.offsetLeft;
    scrollLeft = scrollContainer.scrollLeft;
  }, { passive: true });

  scrollContainer.addEventListener('touchmove', (e) => {
    if (!isScrolling) return;
    e.preventDefault();
    const x = e.touches[0].pageX - scrollContainer.offsetLeft;
    const walk = (x - startX) * 2; // Scroll speed multiplier
    scrollContainer.scrollLeft = scrollLeft - walk;
  }, { passive: false });

  scrollContainer.addEventListener('touchend', () => {
    isScrolling = false;
  }, { passive: true });

  // Add mouse wheel support for desktop
  scrollContainer.addEventListener('wheel', (e) => {
    e.preventDefault();
    scrollContainer.scrollLeft += e.deltaY;
  }, { passive: false });
}

// initial + dynamic sections

// Ensure initialization on initial load and when sections render in the theme editor
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => window.setupEnhancedImages());
} else {
  window.setupEnhancedImages();
}

document.addEventListener('shopify:section:load', (e) => {
  if (e?.target) window.setupEnhancedImages(e.target);
});
document.addEventListener('shopify:section:select', (e) => {
  if (e?.target) window.setupEnhancedImages(e.target);
});

document.addEventListener('DOMContentLoaded', () => {

  
  // Additional mobile-specific settings
  
    // Support both old and new class names
    const selectors = [
      '.swiper-enhanced-images .swiper',
      '.swiper-megamenu-images .swiper-megamenu'
    ];
    
    selectors.forEach(selector => {
      document.querySelectorAll(selector).forEach((el) => {
        if (el.swiper) {
          el.swiper.params.slidesPerView = 1.1;
          el.swiper.update();
        }
      });
    });
  
})

